'use strict';

module.exports = require('./Switch');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.1.4.2@rc-switch/lib/index.js
 ** module id = 387
 ** module chunks = 0
 **/